export default {
  form: {
    header: {
      label: 'Encabezado',
      placeholder: 'Encabezado',
    },
    qr_code_header: {
      label: 'Título del cuadro',
      placeholder: 'Título del cuadro',
    },
    qr_code_description: {
      label: 'Descripción del cuadro',
      placeholder: 'Descripción del cuadro',
    },
    tag_text: {
      label: 'Texto de etiqueta',
      placeholder: '¡NUEVO!',
    },
    footer: {
      label: 'Texto del pie',
      placeholder: 'Ingrese texto del pie',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Seleccionar URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Color primario',
    },
    background_color: {
      label: 'Color de fondo',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar el folleto',
  },
};
